import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { AsyncPipe, CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { MarkdownModule } from "ngx-markdown";

import { BotComponent } from "./components/messages/bot/bot.component";
import { UserComponent } from "./components/messages/user/user.component";
import { ErrorBannerComponent } from "./components/error-banner/error-banner.component";
import { LinkConfirmationModalComponent } from "./components/link-confirmation-modal/link-confirmation-modal.component";
import { ChatProvider } from "./services/chat-provider.interface";
import { HttpChatProviderService } from "./services/http-chat-provider.service";

@NgModule({
  declarations: [
    BotComponent,
    UserComponent,
    ErrorBannerComponent,
    LinkConfirmationModalComponent,
  ],
  imports: [
    AsyncPipe,
    CommonModule,
    FormsModule,
    HttpClientModule,
    MarkdownModule.forChild()
  ],
  providers: [
    { provide: ChatProvider, useClass: HttpChatProviderService }
  ],
  exports: [
    BotComponent,
    UserComponent,
    ErrorBannerComponent,
    LinkConfirmationModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
